<template>
  <div class="flex justify-end pb-2">
    <AppBtn
      v-if="(resumeStatus == 'resumable' || resumeStatus == 'resuming') && resumeMechanism == 'cache'"
      :loading="resumeStatus == 'resuming'"
      prepend-icon="mdi:refresh"
      color="primary"
      rounded
      @click="$emit('resume')"
    >
      {{ $tt('resume_saved_form') }}
    </AppBtn>
    <SaveForm :form />
  </div>
</template>

<script setup lang="ts">
import type { VisaForm } from '~/types';

const props = defineProps<{
  form: VisaForm;
}>();

const { resumeStatus, resumeMechanism } = useFormResume(props.form.country);

defineEmits(['resume']);
</script>